import React from "react";
import Context from "../../../../../context";
import {
  CustomModal,
  CustomView,
  PlateNumber,
  UserInformation,
} from "../../../../../components";
import utils from "../../../../../utils";
import dictionary from "../../../../../dictionary";
import { useTranslation } from "react-i18next";

const DriverInformation = () => {
  const { showModal, setShowModal, selectedUser } = React.useContext(
    Context.ServiceScreen
  );

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"40vw"}
        maxWidth={"50vw"}
        open={showModal === "SHOW_DRIVER_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedUser?.avatar}
            name={
              selectedUser?.firstName
                ? selectedUser?.firstName
                : selectedUser?.name
            }
            lastName={selectedUser?.lastName ? selectedUser?.lastName : ""}
            phoneNumber={
              selectedUser?.phoneNumber
                ? selectedUser?.phoneNumber
                : selectedUser?.telephone
            }
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedUser?.gender && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("gender")} :</label>
                <p>{dictionary.genderEnglish2Persian(selectedUser?.gender)}</p>
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.carBrand && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("carBrand")}:</label>
                <p>{selectedUser?.driverInformation?.carBrand}</p>
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.carColor && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("carColor")}:</label>
                <p>{selectedUser?.driverInformation?.carColor}</p>
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.carModel && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("carModel")}:</label>
                <p>{selectedUser?.driverInformation?.carModel}</p>
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.carSystem && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("carSystem")}:</label>
                <p>{selectedUser?.driverInformation?.carSystem}</p>
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.driverLicenseNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("licenceNumber")}:</label>
                <p>{selectedUser?.driverInformation?.driverLicenseNumber}</p>
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.insuranceExpiryDate && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("insuranceExpire")}:</label>
                <p>
                  {utils.convertGregorianToJalali({
                    date: selectedUser?.insuranceExpiryDate,
                    format: "jYYYY/jMM/jDD",
                  })}
                </p>
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.plateNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("plateNumber")}:</label>
                <PlateNumber
                  tagNum={selectedUser?.driverInformation?.plateNumber}
                  editor={false}
                  onChange={() => true}
                />
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.insuranceNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("insuranceNumber")}:</label>
                <p>{selectedUser?.driverInformation?.insuranceNumber}</p>
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.nationalCode && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("nationalCode")}:</label>
                <p>{selectedUser?.driverInformation?.nationalCode}</p>
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.uniqueCodeThirdPartyInsurance && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">
                  {t("insuranceUniqueCode")}:
                </label>
                <p>
                  {
                    selectedUser?.driverInformation
                      ?.uniqueCodeThirdPartyInsurance
                  }
                </p>
              </CustomView.Column>
            )}
            {selectedUser?.driverInformation?.vin && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("vin")}:</label>
                <p>{selectedUser?.driverInformation?.vin}</p>
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default DriverInformation;
